// This file was automatically generated from uiwidget.LegacyMindreader.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.LegacyMindreader');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer">', (opt_data.hasCountInfo) ? '<div class="mr-results-info el8MRInformText"></div>' : '');
  var sectionList465 = opt_data.sections;
  var sectionListLen465 = sectionList465.length;
  if (sectionListLen465 > 0) {
    for (var sectionIndex465 = 0; sectionIndex465 < sectionListLen465; sectionIndex465++) {
      var sectionData465 = sectionList465[sectionIndex465];
      output.append((sectionData465.title) ? '<p class="mr-title-' + soy.$$escapeHtml(sectionData465.name) + ' mr-descriptionText mr-subheader el8MRHeader">' + soy.$$escapeHtml(sectionData465.title) + '</p>' : '', '<div class="mr-', soy.$$escapeHtml(sectionData465.name), ' mr-subheader el8MRSection"></div>');
    }
  } else {
    output.append('<div class="mr-matches el8MRSection"></div>');
  }
  output.append((opt_data.hasActions) ? '<div class="mr-actions"></div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.noMatchesFyi = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="mr-fyi el8MRInformText">', (! opt_data.text) ? 'No matches found' : soy.$$escapeHtml(opt_data.text), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.item = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown-item');
  var cList493 = opt_data.classes;
  var cListLen493 = cList493.length;
  for (var cIndex493 = 0; cIndex493 < cListLen493; cIndex493++) {
    var cData493 = cList493[cIndex493];
    output.append(' ', soy.$$escapeHtml(cData493));
  }
  output.append(' el8MRItem" role="listitem" _mr_list="', soy.$$escapeHtml(opt_data.listName), '" _mr_index="', soy.$$escapeHtml(opt_data.index), '"></div>');
  if (!opt_sb) return output.toString();
};
